import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service";
import { MainService } from "../../services/main.service";
import { InPurchasesService } from "../../services/inventory/in-purchases.service";
export interface ConfirmModelPurchase {
  title: string;
  data: any;
  Name: string
  type:number
}
@Component({
  selector: 'app-purchasehistory',
  templateUrl: './purchasehistory.component.html',
  styleUrls: ['./purchasehistory.component.css']
})
export class PurchasehistoryComponent extends DialogComponent<ConfirmModelPurchase, boolean> implements ConfirmModelPurchase, OnInit {
  @Input() onReturn: string;
  title: string;
  message: string;
  loading: boolean = true;
  data: any;
  fullData: any;
  Name: any
  fromDate: Date=new Date()
  toDate: Date=new Date()
  isLoaded: boolean = true;
  masterload: boolean = false;
  historydata: any = []
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  dates: any
  model: any
  type:number=3
  private el: ElementRef;
  constructor(dialogService: DialogService, private ds: DataService, private pds: InPurchasesService) {
    super(dialogService);
    this.fullData = this.data
    this.Name = this.Name
  }
  getPage: any = { page: 1, limit: 10, start: 10, searchText: "" };
  getPageTrans: any = { page: 1, limit: 10, start: 10, searchText: "" };
  config: any = {
    offset: 1,
    range: 3,
    colunms: [],
    data: [],
    Action: false,
    Actions: {}
  };
  limit: number = 10;
  requesteddata: any = {
    LocationId: this.ds.Settings.LocationId,
    Barcode: '',
    Fromdate: new Date(),
    Todate: new Date(),
    Type:3, //3- Purchase ,1-Lpo ,2- Grn ,4- Purchase Return
    RequestedList: {
      Start: 0,
      FiterText: "",
      Limit: this.limit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
  }
  ngOnInit() {

    // this.dates = new Date();
    // this.dates = new Date(this.dates.getFullYear().toString() + "-" + this.dates.getMonth().toString() + "-1").toDateString();
    this.fromDate = new Date();
    this.toDate = new Date;
    this.fromDate.setDate(this.fromDate.getDate() - 30);
    // this.isLoaded = true;
    this.loading = false
    this.model = {
      SellingPrice: 0,
      Stock: 0,
      Margin: 0,
      MarginPerc: 0
    }
    if (!this.data) {
      this.close();
    } else {
      this.loading = false;
    }
    this.getHistorymaster();
    this.getPurchaseHistory();
  }
  getHistorymaster() {
    // this.loading = true;
    this.Name = this.Name
    this.requesteddata.LocationId = this.ds.Settings.LocationId
    this.requesteddata.Barcode = this.data
    this.pds.getPurchasestock(this.requesteddata).subscribe(res => {
      if (res.Success) {
        // this.isLoaded = false;
        this.loading = true
        this.model.SellingPrice = res.data.Sellingprice
        this.model.Stock = res.data.currentstock
        this.model.Margin = res.data.Margin
        this.model.MarginPerc = res.data.Marginperc
        this.loading = false;
        // this.isLoaded = true;
      }
      // this.loading = false
      // this.isLoaded = false;
    })
  }
  getPurchaseHistory() {
    this.isLoaded = false;
    this.loading = true;
    this.requesteddata.Fromdate = this.fromDate
    this.requesteddata.ToDate = this.toDate
    this.requesteddata.LocationId = this.ds.Settings.LocationId
    this.requesteddata.RequestedList.FiterText = this.getPage.searchText
    this.requesteddata.Barcode = this.data
    this.requesteddata.Type=this.type;
    this.pds.getPurchaseHistory(this.requesteddata).subscribe(res => {
      if (res.Success) {
        this.historydata = res
        this.LoadTable();
        this.loading = false;
      }
      this.isLoaded = true;
    }
    )
  }
  LoadTable() {
    this.config.offset = 1;
    this.config.range = 1;
    this.config.colunms = [
      { Name: "Location", width: "70px", Heading: "Location", Id: 1 },
      { Name: "Date", width: "70px", Heading: "Date", Id: 2, Formate: "date" },
      { Name: "Supplier", width: "70px", Heading: "Supplier", Id: 3 },
      { Name: "RefNo", width: "70px", Heading: "RefNo", Id: 4 },
      // { Name: "Barcode", width: "70px", Heading: "Barcode", Id: 5 },
      // { Name: "Name", width: "70px", Heading: "Itemname", Id: 6, Formate: "text", Aling: 'left' },
      // { Name: "Unit", width: "70px", Heading: "Unit", Id: 7},
      { Name: "Quantity", width: "70px", Heading: "Quantity", Id: 7 },
      { Name: "Rate", width: "70px", Heading: "Rate", Id: 8, Formate: "decimal", Aling: 'right' },
      { Name: "Amount", width: "70px", Heading: "Amount", Id: 9, Formate: "decimal", Aling: 'right' },
      { Name: "Note", width: "70px", Heading: "Note", Id: 10 },
      // { Name: "TotalAmount", width: "70px", Heading: "Total", Id: 12, Formate: "decimal", Aling: 'right' },
    ];
    this.config.data = this.historydata.data;
    this.loading = false
  }
  pagechange(v: any) {

    this.getPage = v;
    this.requesteddata.RequestedList.Start = v.start;
    this.requesteddata.RequestedList.limit = v.limit;
    this.limit = v.limit;
    this.getPurchaseHistory();
    this.loading = true
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/purchasehistory/purchasehistory.component.ts